import Vue from 'vue'

// axios
import axios from 'axios'

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  // baseURL: 'http://localhost:3001',
  baseURL: 'https://api.kipli.tech',
  // timeout: 1000,
})

Vue.prototype.$http = axiosIns

export default axiosIns
